"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Introduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="introdução" className="bg-background py-[160px]">
      <div className="mx-auto max-w-[1280px] px-6 md:px-8 lg:px-12">
        <div ref={ref} className={`border-l-2 border-primary pl-6 md:pl-10 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <p className="max-w-4xl font-sans text-xl leading-relaxed text-muted-foreground md:text-[20px] md:leading-[1.8]">
            A ITC+ atua com produção audiovisual e criação de conteúdo para empresas, especialistas e marcas que desejam crescer com presença digital e autoridade.
          </p>
        </div>
      </div>
    </section>;
}